export const logOutAPI = async (access_token) => {
  try {
    const headers = new Headers();
    headers.append("Authorization", `Bearer ${access_token}`);
    headers.append("Content-Type", "application/json");

    const res = await fetch(`${process.env.REACT_APP_BASE_URL}/api/logout`, {
      headers,
      method: "POST",
    });
    return res;
  } catch (error) {
    return null;
  }
};
